
export interface ProductFilters {
    id: string | undefined;
    price_from: string | undefined;
    price_to: string | undefined;
    category: string | undefined;
    brandName: string | undefined;
    city_id?: string | undefined;
    category_name?: string | undefined;
  }
  export const filterInitialData: ProductFilters = {
    id: "",
    price_from: "",
    price_to: "",
    category: "",
    brandName: "",
    city_id: "",
    category_name: "",
  };

  export interface ProductFiltersModalProps {
    open: boolean;
    onClose: () => void;
    onApply: (filters: ProductFilters) => void;
    filters: ProductFilters;
    setFilters: (filters: ProductFilters) => void;
    tenantId: string;
    showPriceRange?: boolean;
    showCategories?: boolean;
    showCities?: boolean;
    filterWithTenantCategoryParam?: boolean;
  }